/*
Componentes para seleccionar la fecha y hora
*/

import React from 'react'
import PropTypes from 'prop-types'

// CONSTANT
import { CALCULATEDATEMORETHAN18 } from '../constants'

// #region DATERPICKER
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import 'date-fns'
import esLocale from 'date-fns/locale/es'
import DateFnsUtils from '@date-io/date-fns'
// #endregion

export default function DatePicker({
  value,
  onChange,
  onBlur,
  disabled,
  required,
  error
}) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
      <KeyboardDatePicker
        fullWidth
        inputVariant='outlined'
        variant='inline'
        format='dd/MM/yyyy'
        error={error}
        required={required}
        disabled={disabled}
        id='date-picker-outlined'
        label={<span data-lang="profile_birthdate_label">Fecha nacimiento</span>}
        labelwidth='200'
        invalidDateMessage='Formato incorrecto'
        minDateMessage='Fecha no válida'
        maxDateMessage='No eres mayor de edad'
        value={value}
        onChange={event => {
          if (event && !isNaN(event)) {
            const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()))
            onChange(
              d.toISOString().slice(0, 10)
            )
          } else {
            onChange(null)
          }
        }}
        onBlur={onBlur}
        KeyboardButtonProps={{
          'aria-label': 'change date',
          'data-lang-attr': 'aria-label',
          'data-lang-aria-label': 'date_change_aria'
        }}
        minDate={new Date('1900-01-02')}
        maxDate={CALCULATEDATEMORETHAN18()}
      />
    </MuiPickersUtilsProvider>
  )
}

DatePicker.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  required: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired
}
